import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        margin: 4
    },
    container: {
        position: 'relative',
    },
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default function NativeSelects({ inputId, inputName, label, handleStateChange, value }) {
    const classes = useStyles();

    const handleOnChange = name => event => {
        handleStateChange(inputId, event.target.value);
    };

    return (
        <div className={classes.root}>
            <FormControl fullWidth className={classes.formControl}>
                <InputLabel shrink htmlFor={inputId}>{label}</InputLabel>
                <NativeSelect 
                    fullWidth
                    value={value}
                    onChange={handleOnChange('selectedValue')}
                    input={
                        <Input
                            name={inputName}
                            id={inputId} />
                    }>
                    <option value="" />
                    <option value={1}>Room 1</option>
                    <option value={2}>Room 2</option>
                </NativeSelect>
            </FormControl>
        </div>
    );
}